import { REHYDRATE } from 'redux-persist/constants'
import { NEW_NOTIFICATION, RESET_NOTIFICATION } from '../actions/toastNotification'

export default (state = {}, action) => {
  switch (action.type) {
    case NEW_NOTIFICATION:
      return {
        ...action.payload,
      }
    case RESET_NOTIFICATION:
      return {}
    case REHYDRATE:
      return {}
    default:
      return state
  }
}
